<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import StudentServices from "../../../services/student";
import AlertError from "@/components/alert_error";

export default {
  components: { AlertError },
  data() {
    return {
      //Page errors.
      errors: [],
      showAlert: false,
      notFoundStudent: false,

      results: [],

      // vuelidate
      inputSearch: "",

      submitted: false,
      loadingButton: false,
    };
  },
  validations: {
    inputSearch: { required, minLength: minLength(11), maxLength: maxLength(11) },
  },
  methods: {
    handleError(error) {
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    reset() {
      this.errors = [];
      this.results = [];
      this.loadingButton = false;
      this.submitted = false;
      this.notFoundStudent = false;
    },
    isFound() {
      return Array.isArray(this.results) && this.results.length > 0;
    },
    notfoundResult() {
      this.reset();
      this.notFoundStudent = true;
    },
    search() {
      this.reset();

      this.submitted = true;
      this.$v.$touch();
      if (this.$v.inputSearch.$error) return;

      // to form submit after this
      this.loadingButton = true;

      StudentServices.getStudentByPhoneNumber({ phone: this.inputSearch })
        .then((response) => {
          this.results = response.data.data;

          //check if not found
          if (!this.isFound()) this.notfoundResult();

          this.loadingButton = false;
        })
        .catch((error) => {
          this.reset();
          this.handleError(error);
        });
    },
  },
  mounted() {},
};
</script>

<template>
  <div>
    <section
      class="section"
      id="features"
      style="min-height: calc(100vh - 105px); padding-top: 40px"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mb-5">
              <a href="https://emtenan.org/"><h4>منصة إمتنان</h4></a>
              <h5>
                <div class="small-title">
                  استمارة المنح الدراسية في الجمهورية الاسلامية الايرانية
                </div>
              </h5>
              <h5>
                <div class="small-title">معرفة نتيجة التقديم</div>
              </h5>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>
              <b-form class="mb-5" @submit.prevent="search">
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group
                      class="col-md-12 mb-3"
                      label="ابحث عن طريق رقم الهاتف :"
                      label-for="username"
                    >
                      <b-form-input
                        v-model="inputSearch"
                        :class="{
                          'is-invalid': submitted && $v.inputSearch.$error,
                        }"
                        id="inputSearch"
                        type="number"
                        placeholder="ادخل رقم الهاتف"
                      ></b-form-input>
                      <div
                        v-if="submitted && $v.inputSearch.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.inputSearch.required">
                          ادخل رقم الهاتف ثم قم بالبحث
                        </span>
                        <span v-if="!$v.inputSearch.minLength">
                          يجب ان يتكون رقم الهاتف من 11 رقم .
                        </span>
                        <span v-if="!$v.inputSearch.maxLength">
                          يجب ان يتكون رقم الهاتف من 11 رقم .
                        </span>
                      </div>
                    </b-form-group>
                    <b-button
                      class="btn-block col-12"
                      type="submit"
                      variant="primary"
                      :disabled="this.loadingButton"
                    >
                      <b-spinner v-if="this.loadingButton" small></b-spinner>
                      <span v-else>
                        <i class="bx bx-search-alt font-size-16 align-middle me-2"></i
                        >بحث</span
                      >
                    </b-button>
                  </div>

                  <div v-if="notFoundStudent" class="col-md-12 mt-4">
                    <div class="text-center mt-4">
                      <h4>لاتوجد نتائج</h4>
                    </div>
                  </div>

                  <div v-if="results.length > 0">
                    <div
                      v-for="student in results"
                      :key="student.id"
                      class="col-md-12 mt-4"
                    >
                      <BCard header-class="bg-transparent pt-3 pb-0">
                        <template v-slot:header>
                          <h5 class="my-0 d-flex align-items-center font-color-blue">
                            <i class="font-size-24 mdi mdi-account me-2"></i
                            >{{ student.full_name }}
                          </h5>
                        </template>
                        <BCardTitle class="mb-3"
                          >حالة القبول : {{ student.student_status.title }}</BCardTitle
                        >
                        <BCardText>
                          {{ student.status_note }}
                        </BCardText>
                        <BCardText class="d-grid justify-content-end">
                          <small>تاريخ التقديم</small>
                          <p class="mb-0 text-muted">{{ student.created_at }}</p>
                        </BCardText>
                      </BCard>
                    </div>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
    <!-- Features end -->

    <!-- Footer start -->
    <footer class="landing-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <img src="@/assets/images/logo.png" alt height="25" />
            <span class="mx-2">منصة امتنان</span>
          </div>
          <div class="col-md-6">
            <p class="mt-1 text-md-end d-sm-block mb-0">
              {{ new Date().getFullYear() }} © جميع الحقوق محفوظة
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer end -->
  </div>
</template>
